import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hwdi-responsible-service',
  templateUrl: './responsible-service.component.html',
  styleUrls: ['./responsible-service.component.scss']
})
export class ResponsibleServiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
